import {initSnowfall} from "@/helpers/snowflake-effect";

document.addEventListener('DOMContentLoaded', () => {
    initSnowfall();
});
